import { defineMessages } from "react-intl";

const messages = defineMessages({
  datePlaceholder: {
    id: "formFields.date.placeholder",
    defaultMessage: "Select date",
    description: "Placeholder for date field",
  },
  emailPlaceholder: {
    id: "formFields.email.placeholder",
    defaultMessage: "Email",
    description: "Placeholder for email field",
  },
  fieldRequired: {
    id: "formFields.validator.required",
    defaultMessage: "{fieldName} is required",
    description: "An error message to appear when field's value is not provided",
  },
  fileRequired: {
    id: "formFields.files.validator.required",
    defaultMessage: "File is required. Please upload at least one file.",
    description: "An error message to appear when files are not provided",
  },
  maskedTooltip: {
    id: "formFields.name.masked.tooltip",
    defaultMessage: "Protected Information",
    description: "Tooltip to show when name field is masked",
  },
  mustBeUnique: {
    id: "formFields.name.masked.mustBeUnique",
    defaultMessage:
      "Values must be unique, so this field cannot be used when adding records in bulk.",
    description: "Unique cf disabled caption",
  },
  namePlaceholder: {
    id: "formFields.name.placeholder",
    defaultMessage:
      "{sourceObject, select, standard {{entityName}} leadCompanies {Lead} siteCompanies {Site} projectCompanies {Project} shopCompanies {Shop} partnerPeople {Partner} leadPeople {Lead} staffMemberPeople {Staff Member} leadPersonnel {Lead Personnel} other {{label}}} name",
    description:
      'Placeholder for name field. The record type name comes from the select: the web\'s own word for a known type, otherwise {label}, a name an admin typed or an integration sent. Keep {label} in its base form. In es, pt and fr, no article, adjective or participle may agree with it: put gendered words on the noun "record" with the name in parentheses, or put a verb before the name. In a choice that creates a record, use a form like "Добавить: {label}".',
  },
  timePlaceholder: {
    id: "formFields.time.placeholder",
    defaultMessage: "Select time",
    description: "Placeholder for time field",
  },
});

export default messages;
